import {
  EnvironmentProviders,
  inject,
  provideAppInitializer,
} from '@angular/core';
import { TranslocoService, getBrowserLang } from '@jsverse/transloco';

interface AppI18nLanguageOptions {
  readonly availableLangs: readonly string[];
  readonly fallbackLang: string;
  readonly storageKey: string;
}

export function resolveActiveLanguage(
  options: AppI18nLanguageOptions,
  storedLang: string | null,
  browserLang: string | undefined,
): string {
  const candidate =
    storedLang && storedLang !== 'undefined' ? storedLang : browserLang;

  return candidate && options.availableLangs.includes(candidate)
    ? candidate
    : options.fallbackLang;
}

export function provideTranslocoActiveLanguage(
  options: AppI18nLanguageOptions,
): EnvironmentProviders {
  return provideAppInitializer(() => {
    const transloco = inject(TranslocoService);

    const storedLang = localStorage.getItem(options.storageKey);
    const activeLang = resolveActiveLanguage(
      options,
      storedLang,
      getBrowserLang(),
    );

    transloco.setActiveLang(activeLang);
  });
}
